import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { PlaceOutlined } from '@mui/icons-material';
import { useFacilityMaintenanceEditor } from '../../../../../hooks/useFacilityMaintenanceEditor';
import { EditorMode } from '../../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const FacilityMaintenanceLocationDetailEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useFacilityMaintenanceEditor(mode);

  const handleChange = (value: string) => {
    updateRequest({ locationDetail: value });
  };

  return (
    <TextField
      label="Location Detail"
      value={request?.locationDetail || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      placeholder="e.g., Building A, Room 201"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <PlaceOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FacilityMaintenanceLocationDetailEditor;
